import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faTrash, faEdit, faArrowUp, faArrowDown, faSync,
    faUtensils, faSearch, faFileExcel, faFilePdf, faImages,
    faFire, faTag, faExternalLinkAlt
} from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ProductosData.css';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import baseURL from '../../url';
import NewProduct from '../NewProduct/NewProduct';
import moneda from '../../moneda';
import { Link as Anchor } from 'react-router-dom';

export default function ProductosData() {
    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [producto, setProducto] = useState({});
    
    // Form fields
    const [nuevoTitulo, setNuevoTitulo] = useState('');
    const [nuevaDescripcion, setNuevaDescripcion] = useState('');
    const [nuevoPrecio, setNuevoPrecio] = useState('');
    const [nuevoPrecioAnterior, setNuevoPrecioAnterior] = useState(0);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [nuevoMasVendido, setNuevoMasVendido] = useState('');
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');

    // Images
    const [selectedSection, setSelectedSection] = useState('texto');
    const [modalImagenVisible, setModalImagenVisible] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState('');
    const [imagenPreview, setImagenPreview] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    const [nuevaImagen, setNuevaImagen] = useState(null);
    const [nuevaImagen2, setNuevaImagen2] = useState(null);
    const [nuevaImagen3, setNuevaImagen3] = useState(null);
    const [nuevaImagen4, setNuevaImagen4] = useState(null);

    // Filters & Sorting
    const [busqueda, setBusqueda] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroMasVendido, setFiltroMasVendido] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);

    useEffect(() => {
        cargarProductos();
        cargarCategorias();
    }, []);

    useEffect(() => {
        if (producto.idProducto) {
            setNuevoTitulo(producto.titulo || '');
            setNuevaDescripcion(producto.descripcion || '');
            setNuevoPrecio(producto.precio || '');
            setNuevoMasVendido(producto.masVendido || 'no');
            setNuevaCategoria(producto.idCategoria || '');
            setNuevoPrecioAnterior(producto.precioAnterior || 0);
            setItem1(producto.item1 || '');
            setItem2(producto.item2 || '');
            setItem3(producto.item3 || '');
            setItem4(producto.item4 || '');
            setItem5(producto.item5 || '');
            setItem6(producto.item6 || '');
            setItem7(producto.item7 || '');
            setItem8(producto.item8 || '');
            setItem9(producto.item9 || '');
            setItem10(producto.item10 || '');
        }
    }, [producto]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`)
            .then(res => res.json())
            .then(data => setProductos(data.productos || []))
            .catch(err => console.error('Error al cargar productos:', err));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(res => res.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(err => console.error('Error al cargar categorías:', err));
    };

    const eliminarProducto = (idProducto) => {
        Swal.fire({
            title: '¿Eliminar producto?',
            text: '¡Esta acción no se puede revertir!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/productosDelete.php?idProducto=${idProducto}`, {
                    method: 'DELETE',
                })
                    .then(res => res.json())
                    .then(data => {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarProductos();
                    })
                    .catch(err => {
                        console.error('Error al eliminar:', err);
                        toast.error('Error al eliminar el producto');
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setProducto(item);
        setSelectedSection('texto');
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setImagenPreview(null);
        setImagenPreview2(null);
        setImagenPreview3(null);
        setImagenPreview4(null);
    };

    const abrirModalImagenSeleccionada = (img) => {
        if (!img) return;
        setImagenSeleccionada(img);
        setModalImagenVisible(true);
    };

    const handleUpdateText = (idProducto) => {
        const payload = {
            titulo: nuevoTitulo !== '' ? nuevoTitulo : producto.titulo,
            descripcion: nuevaDescripcion !== '' ? nuevaDescripcion : producto.descripcion,
            precio: nuevoPrecio !== '' ? nuevoPrecio : producto.precio,
            precioAnterior: nuevoPrecioAnterior !== '' ? nuevoPrecioAnterior : producto.precioAnterior,
            idCategoria: nuevaCategoria !== '' ? nuevaCategoria : producto.idCategoria,
            masVendido: nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido,
            item1, item2, item3, item4, item5, item6, item7, item8, item9, item10
        };

        fetch(`${baseURL}/productoPut.php?idProducto=${idProducto}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('Actualizado', data.mensaje || 'Producto actualizado con éxito', 'success');
                    cargarProductos();
                    cerrarModal();
                }
            })
            .catch(err => toast.error(err.message));
    };

    const handleImagenChange = (e, setPreview, setImageState) => {
        const file = e.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setImageState(file);
        }
    };

    const handleUpdateImage = (idProducto, imageNum, imageFile) => {
        if (!imageFile) {
            toast.warn('Selecciona una imagen primero');
            return;
        }

        const formData = new FormData();
        formData.append(`imagen${imageNum}`, imageFile);

        fetch(`${baseURL}/productoImgPut.php?idProducto=${idProducto}`, {
            method: 'POST',
            body: formData,
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                } else {
                    toast.success('Imagen actualizada');
                    cargarProductos();
                    cerrarModal();
                }
            })
            .catch(err => toast.error(err.message));
    };

    const handleDeleteImage = (idProducto, imageField) => {
        Swal.fire({
            title: '¿Eliminar imagen?',
            text: 'Se eliminará esta fotografía del producto.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
        }).then(result => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('eliminarImagen', imageField);

                fetch(`${baseURL}/productoImgPut.php?idProducto=${idProducto}`, {
                    method: 'POST',
                    body: formData,
                })
                    .then(res => res.json())
                    .then(data => {
                        toast.success('Imagen eliminada');
                        cargarProductos();
                        cerrarModal();
                    })
                    .catch(err => toast.error(err.message));
            }
        });
    };

    const invertirOrden = () => {
        setProductos([...productos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };

    // Filter products
    const productosFiltrados = productos.filter(p => {
        const searchLower = busqueda.toLowerCase();
        const coincideBusqueda = !busqueda || 
            (p.titulo || '').toLowerCase().includes(searchLower) ||
            p.idProducto.toString().includes(searchLower);

        const coincideCategoria = !filtroCategoria || (p.idCategoria && p.idCategoria.toString() === filtroCategoria.toString());
        const coincideMasVendido = !filtroMasVendido || (p.masVendido || 'no') === filtroMasVendido;

        return coincideBusqueda && coincideCategoria && coincideMasVendido;
    });

    const descargarExcel = () => {
        const data = productosFiltrados.map(p => {
            const cat = categorias.find(c => c.idCategoria === p.idCategoria)?.categoria || 'Sin categoría';
            return {
                'ID': p.idProducto,
                'Título': p.titulo,
                'Categoría': cat,
                'Precio': `${moneda} ${p.precio}`,
                'Precio Anterior': p.precioAnterior ? `${moneda} ${p.precioAnterior}` : '-',
                'Más Vendido': p.masVendido === 'si' ? 'Sí' : 'No',
                'Descripción': p.descripcion || '',
            };
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Productos');
        XLSX.writeFile(wb, 'catalogo_productos.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF('landscape');
        pdf.text('Catálogo de Productos', 14, 12);

        const columns = [
            { title: 'ID', dataKey: 'id' },
            { title: 'Título', dataKey: 'titulo' },
            { title: 'Categoría', dataKey: 'categoria' },
            { title: 'Precio', dataKey: 'precio' },
            { title: 'Más Vendido', dataKey: 'masVendido' },
        ];

        const data = productosFiltrados.map(p => ({
            id: p.idProducto,
            titulo: p.titulo,
            categoria: categorias.find(c => c.idCategoria === p.idCategoria)?.categoria || '-',
            precio: `${moneda} ${p.precio}`,
            masVendido: p.masVendido === 'si' ? 'Sí' : 'No',
        }));

        pdf.autoTable({
            startY: 18,
            columns: columns,
            body: data,
        });

        pdf.save('catalogo_productos.pdf');
    };

    // Métricas rápidas
    const totalProductos = productos.length;
    const masVendidosCount = productos.filter(p => p.masVendido === 'si').length;
    const conDescuentoCount = productos.filter(p => parseFloat(p.precioAnterior) > parseFloat(p.precio)).length;

    return (
        <div className="adminPageContainer">
            <ToastContainer />

            {/* Cabecera Principal */}
            <div className="adminHeaderSection">
                <div className="adminHeaderTitle">
                    <h2><FontAwesomeIcon icon={faUtensils} /> Catálogo de Productos</h2>
                    <p>Gestiona los platos, bebidas y artículos disponibles en el menú digital y punto de venta.</p>
                </div>
                <div className="adminHeaderActions">
                    <NewProduct onProductCreated={cargarProductos} />
                    <button className="adminExportBtn btnExcel" onClick={descargarExcel} title="Exportar a Excel">
                        <FontAwesomeIcon icon={faFileExcel} /> Excel
                    </button>
                    <button className="adminExportBtn btnPdf" onClick={descargarPDF} title="Exportar a PDF">
                        <FontAwesomeIcon icon={faFilePdf} /> PDF
                    </button>
                    <button className="adminActionBtn" onClick={cargarProductos} title="Recargar productos">
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                </div>
            </div>

            {/* Métricas Rápidas */}
            <div className="adminKpisMiniGrid">
                <div className="adminKpiMiniCard">
                    <span>Total Artículos</span>
                    <strong>{totalProductos}</strong>
                </div>
                <div className="adminKpiMiniCard kpiInfo">
                    <span>Categorías</span>
                    <strong>{categorias.length}</strong>
                </div>
                <div className="adminKpiMiniCard kpiWarning">
                    <span>Más Vendidos</span>
                    <strong>{masVendidosCount}</strong>
                </div>
                <div className="adminKpiMiniCard kpiSuccess">
                    <span>En Oferta</span>
                    <strong>{conDescuentoCount}</strong>
                </div>
            </div>

            {/* Barra de Filtros */}
            <div className="adminToolbar">
                <div className="adminSearchBox">
                    <FontAwesomeIcon icon={faSearch} />
                    <input 
                        type="text" 
                        placeholder="Buscar producto por nombre o ID..." 
                        value={busqueda} 
                        onChange={(e) => setBusqueda(e.target.value)} 
                    />
                </div>

                <div className="adminFiltersRow">
                    <select value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)}>
                        <option value="">Todas las Categorías</option>
                        {categorias.map(cat => (
                            <option key={cat.idCategoria} value={cat.idCategoria}>{cat.categoria}</option>
                        ))}
                    </select>

                    <select value={filtroMasVendido} onChange={(e) => setFiltroMasVendido(e.target.value)}>
                        <option value="">Todos (Más vendidos)</option>
                        <option value="si">Solo Más Vendidos</option>
                        <option value="no">Normales</option>
                    </select>

                    <button className="adminActionBtn" onClick={invertirOrden} title="Invertir orden">
                        <FontAwesomeIcon icon={ordenInvertido ? faArrowUp : faArrowDown} />
                    </button>
                </div>
            </div>

            {/* Tabla de Productos */}
            <div className="adminTableCard">
                <div className="adminTableResponsive">
                    <table className="adminTable">
                        <thead>
                            <tr>
                                <th style={{ width: '60px' }}>Foto</th>
                                <th># ID</th>
                                <th>Producto</th>
                                <th>Categoría</th>
                                <th>Precio</th>
                                <th>Estado</th>
                                <th style={{ textAlign: 'center' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productosFiltrados.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="adminEmptyRow">
                                        No se encontraron productos con los filtros seleccionados.
                                    </td>
                                </tr>
                            ) : (
                                productosFiltrados.map(item => {
                                    const cat = categorias.find(c => c.idCategoria === item.idCategoria);
                                    const hasOffer = parseFloat(item.precioAnterior) > parseFloat(item.precio);

                                    return (
                                        <tr key={item.idProducto}>
                                            <td>
                                                {item.imagen1 ? (
                                                    <img 
                                                        src={item.imagen1} 
                                                        alt={item.titulo} 
                                                        className="adminProductThumb"
                                                        onClick={() => abrirModalImagenSeleccionada(item.imagen1)}
                                                        title="Click para ampliar imagen"
                                                    />
                                                ) : (
                                                    <div className="adminProductThumbEmpty">
                                                        <FontAwesomeIcon icon={faUtensils} />
                                                    </div>
                                                )}
                                            </td>
                                            <td><strong>#{item.idProducto}</strong></td>
                                            <td>
                                                <div className="adminProdTitleCell">
                                                    <strong>{item.titulo}</strong>
                                                    {item.descripcion && (
                                                        <small className="adminProdDescShort">{item.descripcion}</small>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <span className="categoriaTag">
                                                    <FontAwesomeIcon icon={faTag} /> {cat?.categoria || 'Sin categoría'}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="adminProdPriceCell">
                                                    <strong className="precioVerde">{moneda} {item.precio}</strong>
                                                    {hasOffer && (
                                                        <span className="precioTachado">{moneda} {item.precioAnterior}</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                {item.masVendido === 'si' && (
                                                    <span className="adminBadge badgeMasVendido">
                                                        <FontAwesomeIcon icon={faFire} /> Popular
                                                    </span>
                                                )}
                                            </td>
                                            <td>
                                                <div className="adminActionBtnGroup" style={{ justifyContent: 'center' }}>
                                                    <Anchor 
                                                        to={`/producto/${item.idProducto}/${(item.titulo || '').replace(/\s+/g, '-')}`}
                                                        className="btnTableAction btnVer"
                                                        target="_blank"
                                                        title="Ver en la tienda"
                                                    >
                                                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                                                    </Anchor>
                                                    <button 
                                                        className="btnTableAction btnEditar" 
                                                        onClick={() => abrirModal(item)}
                                                        title="Editar producto"
                                                    >
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    <button 
                                                        className="btnTableAction btnBorrar" 
                                                        onClick={() => eliminarProducto(item.idProducto)}
                                                        title="Eliminar producto"
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal Vista Ampliada de Imagen */}
            {modalImagenVisible && (
                <div className="adminModalOverlay" onClick={() => setModalImagenVisible(false)}>
                    <div className="modalImageZoomContainer" onClick={(e) => e.stopPropagation()}>
                        <button className="adminModalClose closeFloating" onClick={() => setModalImagenVisible(false)}>&times;</button>
                        <img src={imagenSeleccionada} alt="Vista ampliada" className="imageZoomDisplay" />
                    </div>
                </div>
            )}

            {/* Modal Editar Producto */}
            {modalVisible && producto && (
                <div className="adminModalOverlay">
                    <div className="adminModalContent modalEditProduct">
                        <div className="adminModalHeader">
                            <div className="modalProductTabs">
                                <button 
                                    className={`modalTabBtn ${selectedSection === 'texto' ? 'active' : ''}`}
                                    onClick={() => setSelectedSection('texto')}
                                >
                                    Datos del Producto
                                </button>
                                <button 
                                    className={`modalTabBtn ${selectedSection === 'imagenes' ? 'active' : ''}`}
                                    onClick={() => setSelectedSection('imagenes')}
                                >
                                    <FontAwesomeIcon icon={faImages} /> Galería de Fotos
                                </button>
                            </div>
                            <button className="adminModalClose" onClick={cerrarModal}>&times;</button>
                        </div>

                        <div className="adminModalBody">
                            {selectedSection === 'texto' ? (
                                <div className="productEditForm">
                                    <div className="formRowGrid2">
                                        <div className="adminFormField">
                                            <label>Título del Producto:</label>
                                            <input 
                                                type="text" 
                                                value={nuevoTitulo} 
                                                onChange={(e) => setNuevoTitulo(e.target.value)} 
                                            />
                                        </div>

                                        <div className="adminFormField">
                                            <label>Categoría:</label>
                                            <select 
                                                value={nuevaCategoria} 
                                                onChange={(e) => setNuevaCategoria(e.target.value)}
                                            >
                                                <option value="">Selecciona una categoría</option>
                                                {categorias.map(cat => (
                                                    <option key={cat.idCategoria} value={cat.idCategoria}>{cat.categoria}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="formRowGrid3">
                                        <div className="adminFormField">
                                            <label>Precio de Venta:</label>
                                            <input 
                                                type="number" 
                                                step="0.01"
                                                value={nuevoPrecio} 
                                                onChange={(e) => setNuevoPrecio(e.target.value)} 
                                            />
                                        </div>

                                        <div className="adminFormField">
                                            <label>Precio Anterior (Oferta):</label>
                                            <input 
                                                type="number" 
                                                step="0.01"
                                                value={nuevoPrecioAnterior} 
                                                onChange={(e) => setNuevoPrecioAnterior(e.target.value)} 
                                            />
                                        </div>

                                        <div className="adminFormField">
                                            <label>¿Es más vendido?</label>
                                            <select 
                                                value={nuevoMasVendido} 
                                                onChange={(e) => setNuevoMasVendido(e.target.value)}
                                            >
                                                <option value="no">No</option>
                                                <option value="si">Sí (Destacado)</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="adminFormField">
                                        <label>Descripción:</label>
                                        <textarea 
                                            rows="3"
                                            value={nuevaDescripcion} 
                                            onChange={(e) => setNuevaDescripcion(e.target.value)} 
                                            placeholder="Detalle de los ingredientes, porciones o preparación..."
                                        />
                                    </div>

                                    {/* Opciones / Variantes de Items */}
                                    <div className="productItemsAccordion">
                                        <label className="itemsTitleLabel">Opciones Adicionales / Acompañamientos (Items):</label>
                                        <div className="itemsInputsGrid">
                                            <input type="text" placeholder="Opción 1" value={item1} onChange={e => setItem1(e.target.value)} />
                                            <input type="text" placeholder="Opción 2" value={item2} onChange={e => setItem2(e.target.value)} />
                                            <input type="text" placeholder="Opción 3" value={item3} onChange={e => setItem3(e.target.value)} />
                                            <input type="text" placeholder="Opción 4" value={item4} onChange={e => setItem4(e.target.value)} />
                                            <input type="text" placeholder="Opción 5" value={item5} onChange={e => setItem5(e.target.value)} />
                                            <input type="text" placeholder="Opción 6" value={item6} onChange={e => setItem6(e.target.value)} />
                                            <input type="text" placeholder="Opción 7" value={item7} onChange={e => setItem7(e.target.value)} />
                                            <input type="text" placeholder="Opción 8" value={item8} onChange={e => setItem8(e.target.value)} />
                                            <input type="text" placeholder="Opción 9" value={item9} onChange={e => setItem9(e.target.value)} />
                                            <input type="text" placeholder="Opción 10" value={item10} onChange={e => setItem10(e.target.value)} />
                                        </div>
                                    </div>

                                    <div className="adminModalFooter" style={{ padding: '1rem 0 0 0' }}>
                                        <button className="adminBtnSecondary" onClick={cerrarModal}>Cancelar</button>
                                        <button className="adminBtnPrimary" onClick={() => handleUpdateText(producto.idProducto)}>
                                            Guardar Información
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="productImagesManager">
                                    <div className="imagesGridManager">
                                        {[1, 2, 3, 4].map((num) => {
                                            const currentImg = producto[`imagen${num}`];
                                            const previewState = num === 1 ? imagenPreview : num === 2 ? imagenPreview2 : num === 3 ? imagenPreview3 : imagenPreview4;
                                            const setPreviewState = num === 1 ? setImagenPreview : num === 2 ? setImagenPreview2 : num === 3 ? setImagenPreview3 : setImagenPreview4;
                                            const setImageState = num === 1 ? setNuevaImagen : num === 2 ? setNuevaImagen2 : num === 3 ? setNuevaImagen3 : setNuevaImagen4;
                                            const imageFile = num === 1 ? nuevaImagen : num === 2 ? nuevaImagen2 : num === 3 ? nuevaImagen3 : nuevaImagen4;

                                            return (
                                                <div key={num} className="imageUploadCard">
                                                    <span className="imageSlotLabel">Foto {num}</span>
                                                    <div className="imageSlotPreview">
                                                        {previewState ? (
                                                            <img src={previewState} alt={`Preview ${num}`} />
                                                        ) : currentImg ? (
                                                            <img src={currentImg} alt={`Foto ${num}`} />
                                                        ) : (
                                                            <div className="emptyImageSlot">
                                                                <FontAwesomeIcon icon={faImages} />
                                                                <span>Sin foto</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="imageSlotActions">
                                                        <label className="btnSelectFile">
                                                            Seleccionar
                                                            <input 
                                                                type="file" 
                                                                accept="image/*" 
                                                                style={{ display: 'none' }}
                                                                onChange={(e) => handleImagenChange(e, setPreviewState, setImageState)} 
                                                            />
                                                        </label>

                                                        {imageFile && (
                                                            <button 
                                                                className="btnSaveImageSlot"
                                                                onClick={() => handleUpdateImage(producto.idProducto, num, imageFile)}
                                                            >
                                                                Subir
                                                            </button>
                                                        )}

                                                        {currentImg && !imageFile && (
                                                            <button 
                                                                className="btnDeleteImageSlot"
                                                                onClick={() => handleDeleteImage(producto.idProducto, `imagen${num}`)}
                                                                title="Eliminar foto"
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
